/**
 * A form box's value as a number, or undefined when it is blank.
 *
 * Blank stays undefined so a request never carries NaN into a numeric column, and the
 * backend reads "absent" as "not stated" rather than as zero. The three Entity Master add
 * forms each carried a private copy of this; the product screen imports it instead.
 */
export const toOptionalNumber = (
    value: string | number | null | undefined,
): number | undefined => {
    if (value === '' || value === null || value === undefined) return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};
